import React from 'react';
import parseLastSeen from '../../utils/parseLastSeen';

import './CamerasCell.scss';

const CamerasCell = ({ cameras }) => {
  return (
    <div className="cameras-cell">
      {cameras.map(camera => 
        <div className="cameras-cell__camera-circle"
          key={`${camera.siteId}${camera.model}$${camera.position}`} 
          style={{ backgroundColor: camera.isOnline === 'true' ? '#02a402' : "#cc0026" }}
        >
          <div className="cameras-cell__camera-circle__tooltip">
            <span>{camera.position}</span> 
            <span>{parseLastSeen(camera.lastSeen)}</span> 
          </div>
        </div>
      )}
    </div>
  );
};

export default CamerasCell;